// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"440":"429e9376","581":"429e9376"}[chunkId] + ".chunk.css";
};